import { Toast } from 'tdesign-mobile-vue'

export function notifyError(message: string) {
  Toast({ theme: 'error', direction: "column", message })
}

export function notifySuccess(message: string) {
  Toast({ theme: 'success', direction: "column", message })
}

export function notifyLoading(message: string) {
  Toast({ theme: 'loading', direction: "column", duration: 0, message })
}

export function notifyClear() {
  Toast.clear();
}